<template>
    <div class="gift-list">
        <headerNotice routerName="评论列表"></headerNotice>
        <!-- 搜索框 -->
        <!-- <div class="seach-box">
            <div class="title-wrapper">
                <h2 class="title">
                    <i></i>
                    <span>筛选查询</span>
                </h2>
            </div>
            <div class="input-wrapper">
                <div>
                    <span>评论名称：</span>
                    <el-input class="el-search" v-model="searchInput" placeholder="评论名称"></el-input>
                </div>
                <div class="option-wrapper">
                    <span>评论分类：</span>
                    <el-select v-model="giftType" placeholder="全部">
                        <el-option
                            v-for="item in typeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <div class="option-wrapper">
                    <span>评论状态：</span>
                    <el-select v-model="giftStatus" placeholder="全部">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <el-button class="search-btn" @click="toSearch">查询</el-button>
            </div>
        </div> -->
        <!-- 评论列表 -->
        <div class="gift-list">
            <!-- 表格 -->
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="giftList"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
            
                <el-table-column align="center" prop="productName" label="产品名称" width="100"></el-table-column>
                <!-- <el-table-column align="center" prop="fileName" label="评论图片" width="120">
                    <template slot-scope="scope">
                        <img :src="scope.row.fileName" width="100" height="100">
                    </template>
                </el-table-column> -->
                <el-table-column align="center" prop="title" label="标题"></el-table-column>
                 <el-table-column align="center" prop="sort" label="排序"></el-table-column>
                <el-table-column align="center" label="分类">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">优秀</span>
                        <span v-if="scope.row.type==2">普通</span>
                        <span v-if="scope.row.type==0">待评定</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论状态">
                    <template slot-scope="scope">
                        
                        <span v-if="scope.row.status==2">审核未通过</span>
                        <span v-if="scope.row.status==1">审核通过</span>
                        <span v-if="scope.row.status==0">未审核</span>                        
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评论类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.commentType==2">话题</span>
                        <span v-if="scope.row.commentType==1">商品</span>
                        <span v-if="scope.row.commentType==0">未定</span>
                    </template>
                </el-table-column>
                  <el-table-column align="center" prop="createTime" label="时间"></el-table-column>
                 
                <el-table-column align="center" prop="commentID" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="toEdit(scope.row.commentID)" type="text" size="small">编辑</el-button>
                        <!-- <el-button
                            @click="deleteOnTrialItem(scope.row.commentID)"
                            type="text"
                            size="small"
                        >删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="评论详情" :visible.sync="showDetail"></el-dialog>
        <!--分页-->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            loading: false,
            btnLoading: false,
            totalCount: 0,
            pageSize: 10,
            currentPage: 1,
            showDetail: false,
            searchInput: '',
            giftList: [],
            multipleSelection: [],
            options: [
                { value: 0, label: "全部" },
                { value: 1, label: "上架" },
                { value: 2, label: "下架" }
            ],
            typeOption: [{ value: 0, label: "全部" }],
            giftType: 0,
            giftStatus: 0
        };
    },
    watch: {},
    computed: {},
    methods: {
        toSearch() {
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                MaxResultCount: this.pageSize,
                SkipCount: 0
            }
            this.getAdminOnTrialItem(params)
            this.currentPage = 1
        },
        toEdit(id) {
            this.$router.push({
                path: "/editComment",
                query: {
                    itemID: id
                }
            })
        },
        toAdd() {
            this.$router.push({ path: "/addGift" })
        },
        // 获取分类
        getOnTrialItemCate(params) {
            let self = this;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminOnTrialExchange/GetOnTrialItemCate",
                params: params,
                success(res) {
                    // console.log(res);
                    // self.loading = false
                    self.typeOption = self.dealTypeOption(res)
                },
                fail(res) {
                    // self.loading = false;
                }
            });
        },
        // 处理分类
        dealTypeOption(data) {
            let temp = []
            data.forEach((item) => {
                temp.push({
                    value: item.cateID,
                    label: item.cateName
                })
            })
            temp.unshift({ value: 0, label: "全部" })
            return temp
        },
        // 切换状态
        UpdateBatchStatus(selected, status, isMultiple) {
            if (!selected.length) {
                this.$message.error('请至少勾选一项')
                return
            }
            let itemID = []
            selected.forEach((item) => {
                itemID.push(item.itemID)
            })
            let data = {
                itemID: itemID,
                status: status
            }
            let self = this;
            if (isMultiple) {
                self.btnLoading = true
            }
            $http.PUT({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminOnTrialExchange/UpdateBatchStatus",
                data: data,
                success(res) {
                    // console.log(res);
                    self.$message.success('操作成功！')
                    if (isMultiple) {
                        selected.forEach((item) => {
                            item.status = status
                        })
                        self.btnLoading = false
                    }
                },
                fail(res) {
                    if (isMultiple) {
                        self.btnLoading = false;
                    }
                }
            });
        },
        // 删除
        deleteOnTrialItem(id) {
            debugger
            let params = {
                Id: id
            }
            let self = this;
            // self.loading = true
            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.DELETE({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminOnTrialExchange/DeleteOnTrialItem",
                    params: params,
                    success(res) {
                        // console.log(res);
                        self.$message.success('操作成功！')
                        let params = {
                            Title: self.searchInput,
                            CateID: self.giftType,
                            Status: self.giftStatus,
                            MaxResultCount: self.pageSize
                        }
                        self.getAdminOnTrialItem(params)
                        self.currentPage = 1
                        // self.loading = false
                    },
                    fail(res) {
                        // self.loading = false;
                    }
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //获取评论列表
        getAdminOnTrialItem(params) {
            let self = this;
            self.loading = true
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminOnTrialExchange/GetAdminComment",
                params: params,
                success(res) {
                    // console.log(res);
                    self.giftList = self.dealGiftData(res.items)
                    self.totalCount = res.totalCount
                    self.loading = false
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 处理评论数据
        dealGiftData(data) {
            data.forEach((item) => {
                item.fileName = this.$store.state.apiUrl + item.fileName
            })
            return data
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                MaxResultCount: val
            }
            this.getAdminOnTrialItem(params)
        },
        //跳转到指定页
        handleCurrentChange(val) {
            let skipCount = (val - 1) * this.pageSize;
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                SkipCount: skipCount,
                MaxResultCount: this.pageSize
            }
            this.getAdminOnTrialItem(params)
        },
        statusFilter(status) {
            return status == 1 ? "待处理" : (status == 2 ? '处理中' : '已处理');
        }
    },
    created() {
        this.getAdminOnTrialItem({
            MaxResultCount: this.pageSize
        })
        this.getOnTrialItemCate()
    },
    mounted() { }
};
</script>
<style lang="scss" scoped>
.gift-list {
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title-wrapper {
            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            height: 50px;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding: 0 20px;
        }
        .title {
            display: flex;
            height: 50px;
            align-items: center;
            font-weight: 400;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .option-wrapper {
                margin-left: 40px;
            }
            .option-wrapper:last-of-type {
                margin-right: 40px;
            }
        }
    }

    // 评论列表
    .gift-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-right: 20px;
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
    }
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
}
</style>